import * as yup from 'yup';
export const newAccountPasswordSchema = () =>
  yup
    .string()
    .min(8, 'Must be at least ten (8) characters long')
    .matches(/\d/, 'Must contain at least one (1) number')
    .matches(/[a-z]/, 'Must contain at least one (1) lowercase letter')
    .matches(/[A-Z]/, 'Must contain at least one (1) uppercase letter')
    .required('Password required');
